import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import apiClient from "../../utils/apiClient";
import AboutYouForm from "../../components/preferences/AboutYou";
import BackButton from "../../components/BackButton";

export default function AboutYouPage() {
  const [prefs, setPrefs] = useState(null);

  useEffect(() => {
    apiClient.get(`/users/preferences`).then(res => setPrefs(res.data));
  }, []);

  const handleSave = async (updated) => {
    const res = await apiClient.put(`/users/preferences`, updated);
    setPrefs(res.data);
    toast.success("About you preferences saved.");
  };

  return (
    <div className="max-w-md mx-auto mt-8 space-y-6 px-4">
      <BackButton />
      {prefs && <AboutYouForm prefs={prefs} onSubmit={handleSave} />}
    </div>
  );
}
